(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  // Mega menu + cart preview: Safari-safe detach and dynamic positioning
  document.addEventListener('DOMContentLoaded', function() {
    const navBar = document.querySelector('.vevor-nav-bar');
    const headerEl = document.querySelector('.vevor-header');
    const alertBarEl = document.querySelector('[data-alert-bar]');

    function setTopVar(px) {
      document.documentElement.style.setProperty('--vevor-header-bottom', Math.max(0, Math.round(px)) + 'px');
    }

    function computeHeaderBottom() {
      if (navBar && typeof navBar.getBoundingClientRect === 'function') {
        return navBar.getBoundingClientRect().bottom;
      }
      if (headerEl && typeof headerEl.getBoundingClientRect === 'function') {
        return headerEl.getBoundingClientRect().bottom;
      }
      return (headerEl && headerEl.offsetHeight) ? headerEl.offsetHeight : 120;
    }

    function updateTopVar() { setTopVar(computeHeaderBottom()); }
    const scheduleUpdate = () => {
      if (typeof requestAnimationFrame === 'function') {
        requestAnimationFrame(updateTopVar);
      } else {
        setTimeout(updateTopVar, 0);
      }
    };

    // Initial and reactive updates
    scheduleUpdate();
    window.addEventListener('resize', scheduleUpdate, { passive: true });
    window.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('orientationchange', scheduleUpdate);
    if (alertBarEl && 'MutationObserver' in window) {
      const mo = new MutationObserver(scheduleUpdate);
      mo.observe(alertBarEl, { attributes: true, attributeFilter: ['style','class'] });
    }

    // --- Mega Menu ---
    const megaTrigger = document.querySelector('.vevor-mega-menu-trigger');
    let megaMenu = document.querySelector('.vevor-mega-menu');

    // Detach to <body> to avoid Safari sticky/fixed rendering bugs
    if (megaMenu && !megaMenu.hasAttribute('data-detached')) {
      document.body.appendChild(megaMenu);
      megaMenu.setAttribute('data-detached', 'true');
    }

    if (megaTrigger && megaMenu) {
      let hoverTimeout;

      function openMenu() {
        scheduleUpdate();
        clearTimeout(hoverTimeout);
        megaMenu.classList.add('active');
        megaMenu.setAttribute('aria-hidden', 'false');
        const navLink = megaTrigger.querySelector('.vevor-nav-link');
        if (navLink) navLink.setAttribute('aria-expanded', 'true');
        if (window.vevorMegaMenu && typeof window.vevorMegaMenu.show === 'function') {
          window.vevorMegaMenu.show();
        }
      }

      function closeMenu() {
        hoverTimeout = setTimeout(() => {
          megaMenu.classList.remove('active');
          delete megaMenu.dataset.clickOpen;
          megaMenu.setAttribute('aria-hidden', 'true');
          const navLink = megaTrigger.querySelector('.vevor-nav-link');
          if (navLink) navLink.setAttribute('aria-expanded', 'false');
          if (window.vevorMegaMenu && typeof window.vevorMegaMenu.hide === 'function') {
            window.vevorMegaMenu.hide();
          }
        }, 100);
      }

      megaTrigger.addEventListener('mouseenter', openMenu);
      megaTrigger.addEventListener('mouseleave', closeMenu);
      megaMenu.addEventListener('mouseenter', () => clearTimeout(hoverTimeout));
      megaMenu.addEventListener('mouseleave', () => {
        megaMenu.classList.remove('active');
        delete megaMenu.dataset.clickOpen;
        megaMenu.setAttribute('aria-hidden', 'true');
        const navLink = megaTrigger.querySelector('.vevor-nav-link');
        if (navLink) navLink.setAttribute('aria-expanded', 'false');
        if (window.vevorMegaMenu && typeof window.vevorMegaMenu.hide === 'function') {
          window.vevorMegaMenu.hide();
        }
      });

      // Click-to-toggle support (prevents # jump)
      const triggerLink = megaTrigger.querySelector('.vevor-nav-link');
      if (triggerLink) {
        triggerLink.addEventListener('click', function(e) {
          e.preventDefault();
          if (megaMenu.dataset.clickOpen === 'true') {
            megaMenu.classList.remove('active');
            delete megaMenu.dataset.clickOpen;
            megaMenu.setAttribute('aria-hidden', 'true');
            triggerLink.setAttribute('aria-expanded', 'false');
          } else {
            openMenu();
            megaMenu.dataset.clickOpen = 'true';
            if (e.detail === 0) {
              const firstCategory = megaMenu.querySelector('[data-mega-category]');
              if (firstCategory) firstCategory.focus();
            }
          }
        });

        triggerLink.addEventListener('keydown', function(e) {
          if (e.key === 'ArrowDown') {
            e.preventDefault();
            openMenu();
            const firstCategory = megaMenu.querySelector('[data-mega-category]');
            if (firstCategory) firstCategory.focus();
          }
        });
      }

      const closeControl = megaMenu.querySelector('[data-mega-menu-close]');
      if (closeControl) closeControl.addEventListener('click', closeMenu);

      document.addEventListener('keydown', function(e) {
        if (e.key !== 'Escape' || !megaMenu.classList.contains('active')) return;
        clearTimeout(hoverTimeout);
        megaMenu.classList.remove('active');
        delete megaMenu.dataset.clickOpen;
        megaMenu.setAttribute('aria-hidden', 'true');
        if (triggerLink) {
          triggerLink.setAttribute('aria-expanded', 'false');
          triggerLink.focus();
        }
      });
    }

    // --- Cart Hover Preview ---
    const cartContainer = document.querySelector('.vevor-cart-container');
    let cartPreview = document.querySelector('.vevor-cart-preview');

    // Detach to <body> for Safari reliability
    if (cartPreview && !cartPreview.hasAttribute('data-detached')) {
      document.body.appendChild(cartPreview);
      cartPreview.setAttribute('data-detached', 'true');
    }

    if (cartContainer && cartPreview) {
      let cartTimeout;

      const openCart = () => { scheduleUpdate(); clearTimeout(cartTimeout); cartPreview.classList.add('active'); };
      const closeCart = () => { cartTimeout = setTimeout(() => { cartPreview.classList.remove('active'); }, 120); };

      cartContainer.addEventListener('mouseenter', openCart);
      cartContainer.addEventListener('mouseleave', closeCart);
      cartPreview.addEventListener('mouseenter', () => clearTimeout(cartTimeout));
      cartPreview.addEventListener('mouseleave', () => cartPreview.classList.remove('active'));
    }
  });

  } catch(e) { console.error(e); }
})();
})();
